module.exports = __webpack_public_path__ + "img/icon-border-radius-transparent.1810423e.png";